import { CalculatorSubmitButton, Container } from 'components/common';
import { ClockIcon } from 'components/common/Icons/ClockIcon/ClockIcon';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { scrollToTop } from 'utils/general';
import { setLastAffordabilityCalcPage } from 'utils/localStorage';
import { CalculatorHeader } from '../CalculatorHeader';
import { CalculatorPages } from '../types';
import { criteriasList } from './helpers';
import { HowLongMobileBlock } from './HowLongMobileBlock';
import { CustomerWarningBlock } from './CustomerWarningBlock';

export const BeforeYouStartPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const beforeYouStartSubmitHandler = () => {
    setLastAffordabilityCalcPage(CalculatorPages.financeDetails);
    searchParams.set('section', CalculatorPages.financeDetails);
    setSearchParams(searchParams);
    scrollToTop();
  };

  return (
    <>
      <CalculatorHeader />
      <Container maxWidth={'lg'} className={'md:py-12'}>
        <div className={'xs:flex-col flex md:flex-row md:justify-between'}>
          <div className={'xs:w-full md:w-7/12'}>
            <h1
              className={`text-dark font-satoshiBlack border-light after:bg-main xs:pb-2 xs:text-2.1xl relative border-2 border-x-0 border-t-0 border-solid font-black after:absolute after:-bottom-0.5 after:left-0 after:h-0.5 after:w-1/5 after:content-[''] md:mb-8 md:pb-5 lg:text-4xl`}
            >
              <FormattedMessage id={'affordabilityCalculator.title'} />
            </h1>

            <p className={'text-ash font-satoshiMedium font-medium sm:text-base md:my-4 lg:text-lg'}>
              <FormattedMessage id={'affordabilityCalculator.beforeStart.subHeader'} />
            </p>
            <div className={'flex flex-col gap-4'}>
              <CustomerWarningBlock />
              <HowLongMobileBlock />
            </div>

            <h2
              className={
                'font-satoshiBlack text-main lg:text-2.5xl border-light xs:pb-1 xs:text-1.5xl mb-4 border-2 border-x-0 border-t-0 border-solid font-black sm:text-xl md:pb-3'
              }
            >
              <FormattedMessage id={'affordabilityCalculator.beforeStart.title'} />
            </h2>
            <p className={'text-ash font-satoshiMedium font-medium sm:text-base md:my-5 lg:text-lg'}>
              <FormattedMessage id={'affordabilityCalculator.beforeStart.subTitle'} />
            </p>

            <ul className={'font-satoshiMedium xs:mb-10 list-none pl-6 text-lg font-medium md:mb-20'}>
              {criteriasList.map(({ textId, link }) => (
                <li
                  key={textId}
                  className={`text-ash relative my-2 ml-1 after:absolute after:top-0 after:-left-6 after:content-[url(/src/images/PurpleTick.png)] sm:text-base lg:text-lg`}
                >
                  <FormattedMessage
                    id={textId}
                    values={
                      link
                        ? {
                            a: text => (
                              <a target={'_blank'} rel={'noreferrer'} href={link} className={'text-main'}>
                                {text}
                              </a>
                            ),
                          }
                        : {}
                    }
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className={'xs:hidden sm:pt-16 md:block md:w-4/12 lg:pt-20'}>
            <div className={'border-pinky rounded-2.5xl -mt-1 border border-solid sm:p-7 lg:p-10'}>
              <h3 className={'text-main font-satoshiBlack mb-3 mt-0 flex font-black sm:text-sm lg:text-base'}>
                <FormattedMessage
                  id={'affordabilityCalculator.beforeStart.howLong'}
                  values={{
                    icon: <ClockIcon className={'my-auto flex sm:mr-3 lg:mr-5'} />,
                  }}
                />
              </h3>
              <div className={'text-ash font-satoshiMedium font-medium sm:text-sm lg:text-base'}>
                <p className={'mb-0'}>
                  <FormattedMessage
                    id={'affordabilityCalculator.beforeStart.howLong.text1'}
                    values={{
                      b: text => <b>{text}</b>,
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={'xs:mb-10 flex items-center justify-center'}>
          <CalculatorSubmitButton textKey={'common.confirmContinue'} onClick={beforeYouStartSubmitHandler} />
        </div>
      </Container>
    </>
  );
};
